module.exports = __webpack_public_path__ + "img/half_year_sc.b41db8fe.jpg";